import { Composition, Template } from "typings/flexFramework/FlexDefinitions";
import { BlossomCodeSplitter } from "components/flexFramework/CodeSplitter/BlossomCodeSplitter";
import { moduleDefinitionsMap } from "components/flexFramework/ModuleDefinitions/moduleDefinitionMap";
import { BlossomComponentsFactory } from "components/flexFramework/domain/BlossomComponentsFactory";
import { flexComponentMap } from "components/flexFramework/FlexComponents/flexComponentMap";

export interface BlossomCodeSplitterFactoryProps {
  template?: Template;
  composition?: Composition;
}

/**
 * Factory that builds the proper code splitter
 * By default, return Composition-based code splitter
 */
export class BlossomCodeSplitterFactory {
  public static get = (props: BlossomCodeSplitterFactoryProps) => {
    if (props && props.template) {
      return new BlossomCodeSplitter(
        moduleDefinitionsMap,
        BlossomComponentsFactory.get({ moduleDefinitions: props.template.regions })
      );
    }

    if (props && props.composition) {
      return new BlossomCodeSplitter(
        flexComponentMap,
        BlossomComponentsFactory.get({ flexComponents: props.composition.page.regionList })
      );
    }

    return new BlossomCodeSplitter(flexComponentMap, []);
  };
}
